import type { UserRole } from '../context/RoleContext';

/**
 * Where a role goes when it has no business being where it asked to go.
 *
 * This exists because the denied-permission fallback used to be a hardcoded
 * /workshop, which became a redirect loop the moment a role lost `workshop`:
 * the accountant asks for a denied route, gets sent to /workshop, is denied
 * that too, and is sent to /workshop again. Every role's landing page must be
 * one it can actually load.
 *
 * Lives here rather than in RoleContext because that module exports the
 * RoleProvider component, and react-refresh/only-export-components (ratcheted
 * in CI) objects to mixing component and non-component exports.
 */
export const landingPathForRole = (role: UserRole): string => {
    switch (role) {
        case 'owner': return '/';
        case 'admin': return '/business-health';
        case 'mechanic':
        case 'member': return '/workshop';
        default: return '/settings';
    }
};
